import {DatosAspiranteModel} from './datos-aspirante.model';

export class ConyugeModel {
  Cedula: string = '';
  Nombres: string = '';

  clear() {
    this.Cedula = '';
    this.Nombres = '';
  }
}
